export enum Errors {
  Tokenization = 'tokenizationError',
  CreateProfile = 'createProfileError',
  ConnectProfileWithSubscription = 'connectProfileError',
}
